module.exports = __webpack_public_path__ + "img/D11.504d5143.png";